<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid grid-list-md>
    <v-layout row wrap justify-start align-start>
      <v-flex sm8 xs12 md6>
        <v-card>
          <card-toolbar title="Numara Engelleme /Kaldırma"></card-toolbar>
          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-layout row>
                <v-flex xs12>
                  <v-textarea
                    v-model="phones"
                    :rules="numberRule"
                    required
                    label="İşlem yapılacak numaralar"
                    rows="12"
                  ></v-textarea>
                </v-flex>
                <v-flex>
                  <v-btn @click="process('delete/blacklist')">Numaraların Engellerini Kaldır</v-btn>
                </v-flex>
                <v-flex>
                  <v-btn @click="process('add/blacklist')">Numaraları Engelle</v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 sm8>
        <v-card>
          <card-toolbar title="Engelli Numaralar">
            <v-spacer>
            </v-spacer>
            <v-btn
              v-if="$store.state.user.confirmation <= 3"
              text
              @click="exportExcel()">
              Excel'e Aktar
            </v-btn>
          </card-toolbar>
          <v-card-text v-if="blacklist.length > 0" class="tt">
            <v-lazy
              v-model="isActive"
              :options="{
                threshold: .5
              }"
              min-height="100"
              transition="fade-transition">
              <v-list shaped v-if="blacklist.length > 0">
                <v-subheader>*Numarayı Kopyalamak İçin Tıklatın</v-subheader>
                <v-list-item-group>
                  <v-list-item
                    dense
                    v-for="(list, i) in blacklist" :key="i"
                    @click="copyNumber(list.phone, i)">
                    <v-list-item-icon>
                      <v-icon large>account_circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title :id="'phone' + i" v-text="list.phone">
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-spacer>
                    </v-spacer>
                    <v-list-item-content>
                      <v-list-item-title>Eklenme Tarihi:</v-list-item-title>
                      <v-list-item-subtitle v-text="list.updated_at">
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-lazy>
          </v-card-text>

          <v-card-text v-else class="text-center headline">
            Engellenmiş Numara Bulunmamakta.
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { copyInput, downloadFile } from '../../../misc';
import CardToolbar from '../../Components/CardToolbar.vue';

export default {
  name: 'BlackList',
  components: {
    CardToolbar,
  },
  data: () => ({
    isActive: false,
    phones: '',
    blacklist: [],
    numberRule: [v => !!v || 'Numara girmeden işlem yapamazsınız!'],
  }),
  methods: {
    ...mapActions({ send: 'sendBackend', sendAsync: 'asyncSender' }),
    copyInput,
    downloadFile,
    copyNumber(num, i) {
      this.copyInput(`phone${i}`, true);
      this.$trigger('set:notification', `Kopyalanan Numara: 0${num}`);
    },
    process(url) {
      if (this.$refs.form.validate()) {
        let k = this.phones;
        // eslint-disable-next-line no-return-assign
        ['.', '\n', '\t', '<br>', '<br/>', '</br>'].map(tok => k = k.split(tok)
          .join(','));
        k = k.split(',');

        // eslint-disable-next-line array-callback-return
        k = k.map(val => this.phoneReplace(val.replace(/[^0-9]+/g, '')));
        k = [...new Set(k)].join('\n');

        this.phones = k;
        const data = { phones: this.phones };
        this.send({
          route: url,
          data,
        }).then(() => {
          this.load();
          this.phones = '';
        });
      }
    },
    async load() {
      this.sendAsync({ route: 'show/blacklist' })
        .then(async (res) => {
          this.blacklist = res.data;
        });
    },
    exportExcel() {
      const fileName = `${this.$store.state.user.company_name}-Karaliste`;
      this.axios.get('download/blacklist', {
        responseType: 'arraybuffer',
      }).then((res) => { this.downloadFile(res, fileName); });
    },
    phoneReplace(phone) {
      return phone.substr(phone.length - 10);
    },
  },
  created() {
    this.load();
  },
};
</script>

<style scoped>
  @media screen and (max-width: 600px) {
    .tt {
      overflow-y: scroll;
      max-height: 250px;
    }
  }

  @media screen and (min-width: 600px) {
    .tt {
      overflow-y: scroll;
      max-height: 500px;
    }
  }
</style>
